/** @jsx jsx */
/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import {css, jsx} from '@emotion/core'
import { useOrderTicket } from '../../use-order-ticket'
import { fmt, mediaQueries, parseHtml, show, Flyout} from '../../../twd'

const listCss = css `
    div {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
        white-space: nowrap;
    }
    dt {
        text-align: left;
    }
    dd {
        text-align: right;
        font-weight: 500;
    }
`

const sectionCss = css `
    ${mediaQueries.notXs} {
        paddingRight: 0px;
        paddingLeft: 0px;
    }
`

const issueTooltip = `
    Utilize this table to review the following details pertaining to your bond:
    <ul>
    <li>Coupon: The bond's interest rate, expressed as a percentage of face value.</li>
    <li>Maturity: The date the investor receives their principal due by the issuer, and the issuer's obligation ends.</li>
    <li>Yield to worst: The lowest potential yield for a bond, assuming the issuer doesn't default.</li>
    <li>Yield to maturity: The total return received by holding a bond until its maturity date.</li>
    <li>Credit Ratings: Designations provided by credit rating agencies (Moody's and S&P) that indicate issuer credit quality and likelihood of default.</li>
    <li>Settlement date: The date when ownership of a bond is legally transferred from seller to buyer. Most bonds settle one business day after the trade date.</li>
    <li>Callable: An indication if the bond can be redeemed (called) by the issuer prior to its maturity.</li>
    </ul>
    For additional bond details, please click the “Bond detail” link above the table.
`

export const BondInfo = () => {

    const { bondInfo, action, cusip, isTreasuryAuction, settlement_} = useOrderTicket()
    const issue = bondInfo.issue || {}
    const n = action==='B' ? 'ask' : 'bid'
    const offer = (bondInfo.bestoffer || {})[n] || {}

    return <React.Fragment>
        <div className="row vertical-offset-xxs">
            <div className="col-md-8 col-xs-12" css={sectionCss}>
            {/* <Flyout
                label={<span
                        className="text-truncate"
                        style={{ maxWidth:'300px', display:'inline-block'}}
                        dangerouslySetInnerHTML={{__html:issue.issue}} />}
                className="btn-label btn-flyout h3"
                html={issueTooltip}
            /> */}
            <Flyout
                label={parseHtml(issue.issue)}
                labelStyle={{
                    display:'inline-block',
                    maxWidth:'300px',
                    overflow:'hidden',
                    textOverflow:'ellipsis',
                    whiteSpace:'nowrap',
                }}
                iconStyle={{
                    marginTop: '-10px'
                }}
                className="btn-label btn-flyout text-truncate h3"
                html={issueTooltip}
            />
            </div>
            <div className="col-md-4 col-xs-12 text-right">
                {!isTreasuryAuction && <a href="#" onClick={() => {
                    show('bond-detail', { cusip, from:'order-ticket' })
                }}>Bond detail</a>}
            </div>
        </div>

        <div className="row vertical-offset-xs"><div className="col-md-12"><hr aria-hidden={true} /></div></div>

        <div className="row vertical-offset-sm">
        <dl css={listCss}>
            <div className="col-md-6" css={sectionCss}>
            <dt>Coupon</dt>
            <dd>{isTreasuryAuction ? fmt.empty() : fmt.cpn(issue.coupon, undefined, '%')}</dd>
            <dt>Maturity</dt>
            <dd>{issue.maturity || fmt.empty()}</dd>
            <dt>Yield to worst</dt>
            <dd>{isTreasuryAuction ? fmt.empty() : fmt.ytw3(offer.ytw)}</dd>
            <dt>Yield to maturity</dt>
            <dd>{isTreasuryAuction ? fmt.empty() : fmt.ytw3(offer.ytm)}</dd>
            </div>

            <div className="col-md-6" css={sectionCss}>
            <dt>Moody's Rating</dt>
            <dd>{(issue.moodyRating!=='-' ? parseHtml(issue.moodyRating) : '') || fmt.empty()}</dd>
            <dt>S&amp;P Rating</dt>
            <dd>{(issue.spRating!=='-' ? parseHtml(issue.spRating) : '') || fmt.empty()}</dd>
            <dt>Settlement date</dt>
            <dd>{(isTreasuryAuction ? fmt.mdy(settlement_) : offer.settlement) || fmt.empty()}</dd>
            <dt>Callable</dt>
            <dd>{issue.callableInd==='Y' ? 'Yes' : 'No'}</dd>

            </div>
        </dl></div>
    </React.Fragment>
}